import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { TeamReadinessAvgGraphGroups } from 'Types/SRITypes';
import EmptyState from 'Components/common/components/EmptyState';

type Props = {
  xAxis: string[]
  data: TeamReadinessAvgGraphGroups[]
};

const MultiLineChart: React.FC<Props> = function MultiLineChart(props: Props) {
  const {
    xAxis, data,
  } = props;

  const series = data.length ? data : [{}];
  const options = {
    credits: {
      enabled: false,
    },
    chart: {
      zoomType: 'xy',
      height: 350,
      marginTop: 40,
    },
    title: {
      text: '',
    },
    subtitle: {
      text: '',
    },
    plotOptions: {
      line: {
        pointWidth: 16,
      },
    },
    xAxis: [
      {
        categories: xAxis,
      },
    ],
    yAxis: [
      {
        // Primary yAxis
        lineWidth: 1,
        tickWidth: 1,
        labels: {
          format: '{value}',
        },
        title: {
          text:
            '<span style="font-size: 14px; font: Roboto; font-weight: 700; color: #000">Score</span>',
          align: 'high',
          offset: 0,
          rotation: 0,
          y: -10,
        },
      },
    ],
    tooltip: {
      shared: false,
      useHTML: true,
      // labelFormatter(): string {
      //   return `<span style="font-size:14px; font-weight:
      // 400; font-family: Roboto; color: #61769E;">
      //       <strong>${series}</strong> (<span>${this.x
      //     }</span>)<br/><strong>Score: </strong>${this.y}<br/><strong>Rank: </strong>
      // ${this.series?.userOptions?.rank[this.series.yData.indexOf(this.y)]
      //     }
      //       </span>`;
      // },
    },
    series,
  };
  return (
    <div className="barlinechart">
      {data.length === 0 ? (
        <EmptyState
          msg="No analytics data found"
          detail="Try adjusting your filters to find what you are looking for"
          height="350px"
        />
      )
        : <HighchartsReact highcharts={Highcharts} options={options} />}
    </div>
  );
};

export default MultiLineChart;
